import { DrawerOpenEvent, DrawerCloseEvent } from '@theme/theme-drawer';

/**
 * Keeps `aria-expanded` truthful on the mtn header's drawer triggers (burger
 * and cart button). Stock Horizon does this inside <header-actions>, which the
 * mtn header doesn't render. Only triggers that declare aria-expanded are
 * touched, so the drawers' own close buttons (aria-controls without
 * aria-expanded) are left alone.
 *
 * @param {Event} event
 */
function syncTriggers(event) {
  const drawer = event.target;
  if (!(drawer instanceof Element) || !drawer.id) return;
  const expanded = drawer.hasAttribute('open') ? 'true' : 'false';
  for (const trigger of document.querySelectorAll(`[aria-controls="${drawer.id}"][aria-expanded]`)) {
    trigger.setAttribute('aria-expanded', expanded);
  }
}

document.addEventListener(DrawerOpenEvent.eventName, syncTriggers);
document.addEventListener(DrawerCloseEvent.eventName, syncTriggers);
